import { render, staticRenderFns } from "./ApproveRequestModal.vue?vue&type=template&id=1e86f746&"
import script from "./ApproveRequestModal.vue?vue&type=script&lang=js&"
export * from "./ApproveRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports